import { render } from "./ModalContentAIStrategies.vue?vue&type=template&id=77587fea&scoped=true&lang=true"
import script from "./ModalContentAIStrategies.vue?vue&type=script&lang=js"
export * from "./ModalContentAIStrategies.vue?vue&type=script&lang=js"

import "./ModalContentAIStrategies.vue?vue&type=style&index=0&id=77587fea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77587fea"

export default script